// Copyright © 2021 Move Closer
import { StoreDriver } from '@movecloser/front-core';
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
export const STORE_DRIVER = StoreDriver.Vuex;
